import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box } from '@mui/material';
import { useRef, useState } from 'react';
import { useRootStore } from '../hooks/useRootStore';
import { MDXEditor, MDXEditorMethods } from '@mdxeditor/editor';
import { MdxPlugins } from './MarkdownEditor/MarkdownEditorPlugins';

export interface NewActivityData {
    comment: string,
    timeStart: Date,
    timeEnd: Date,
}

export default function RejectErrorDialog({ issueId, estimatedHours, onSubmit, onCancel }: { issueId: number, estimatedHours: number | null, onSubmit: (rejectReason: string) => void, onCancel: () => void }) {
    
    const [rejectReasonNotSpecified, setRejectReasonNotSpecified] = useState(false);
    const { api } = useRootStore();

    const mdxEditorRef = useRef<MDXEditorMethods>(null);

    const rejectError = async () => {
        const rejectReason = (mdxEditorRef.current?.getMarkdown() ?? '').trim();
        if (rejectReason.length == 0) {
            setRejectReasonNotSpecified(true);
            return false;
        }

        setRejectReasonNotSpecified(false);

        await api.acceptIssue(issueId, estimatedHours ?? 0, true, rejectReason)
            .then(() => onSubmit(rejectReason));
    }

    return (
        <Box>
            <Dialog open={true} onClose={onCancel} maxWidth='lg' fullWidth={true}>
                <DialogTitle>Почему это не ошибка?</DialogTitle>
                <DialogContent>
                    <Box sx={{ mt: 0.5, textAlign: 'left', minHeight: '300px', border: `1px solid ${rejectReasonNotSpecified ? 'red' : '#cccccc'}`, borderRadius: 1 }} onClick={() => mdxEditorRef.current?.focus()}>
                        <MDXEditor
                            ref={mdxEditorRef}
                            markdown={''}
                            plugins={MdxPlugins.standardPlugins(api, issueId)}
                            onChange={() => setRejectReasonNotSpecified(false)}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onCancel}>Отмена</Button>
                    <Button onClick={rejectError}>Это не ошибка</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}